export default __webpack_public_path__ + "static/media/evo-img.4dde83d8.webp";